import { makeStyles } from '@mui/styles'

export const useCustomDataGridStyles = ({ hasDifferentialRow = false }) => {
  const useStyles = makeStyles(theme => ({
    root: {
      border: 'none',
      // remove header padding to align headers with column values
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        padding: theme.spacing(1),
      },
      '& .MuiDataGrid-columnHeader': {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(0),
      },
      '& .MuiDataGrid-cell': {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      '& .MuiDataGrid-columnSeparator': {
        visibility: 'hidden',
      },
      // replace default hover / active-row styling from datagrid
      '& .MuiDataGrid-row': {
        ...(hasDifferentialRow && {
          '&.differential-row': {
            background: theme.palette.error.background,
            boxShadow: 'inset 0px -1px 0px #E0E0E0',
            '&:hover': {
              cursor: 'pointer',
              background: theme.palette.error.hover,
            },
          },
        }),
        '&.total-row': {
          backgroundColor: theme.palette.info.lightBg,
          '&:hover': {
            backgroundColor: theme.palette.info.lightBg,
          },
        },
        [`&:not(.total-row)${hasDifferentialRow ? '&:not(.differential-row)' : ''}`]: {
          '&.Mui-selected': {
            backgroundColor: 'inherit',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
          },
          '&:not(.Mui-selected)': {
            backgroundColor: 'inherit',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
          },
        },
      },
      '& .MuiDataGrid-columnHeader:focus': {
        outline: 'none',
      },
      '& .MuiDataGrid-cell:focus': {
        outline: 'none',
      },
      '& .MuiDataGrid-cell:focus-within': {
        outline: 'none',
      },
      '& .MuiDataGrid-cell.button-cell': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  }))

  return useStyles()
}
